import { renderStatement } from './renderStatement';
import { t } from '@/i18n/translate';
// @ts-ignore
import css from './statementPanel.css';

/**
 * Builds and returns the statement-view DOM element.
 * The caller is responsible for inserting it into the widget container
 * and wiring up the back-button handler.
 *
 * @param onBack  Callback invoked when the user clicks the back button.
 */
export function renderStatementPanel(onBack: () => void): HTMLElement {
  const labelKey = 'Accessibility statement';
  const backLabelKey = 'Back to accessibility menu';
  const label = t(labelKey);
  const backLabel = t(backLabelKey);

  // Store the canonical English key in data-translate(-aria) so translateWidget()
  // re-translates from the correct source on a later language switch. Without it,
  // the first re-sweep would cache whatever language was active at creation time
  // as the "original", and the label/title would freeze in that language forever.
  const $wrapper = document.createElement('div');
  $wrapper.innerHTML = `<style id="cya11y-statement-css">${css}</style>
<div class="cya11y-statement-view" role="region" aria-label="${label}" data-translate-aria="${labelKey}">
  <header class="cya11y-statement-header">
    <button class="cya11y-statement-back-btn" aria-label="${backLabel}" data-translate-aria="${backLabelKey}" title="${backLabel}" data-translate="${backLabelKey}" type="button">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12H5M5 12L12 19M5 12L12 5"
              stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <h2 class="cya11y-statement-title">${label}</h2>
  </header>
  <div class="cya11y-statement-body">
    <div class="cya11y-statement-card cya11y-statement-content"></div>
  </div>
</div>`;

  const $panel = $wrapper.querySelector('.cya11y-statement-view') as HTMLElement;
  const $backBtn = $wrapper.querySelector('.cya11y-statement-back-btn') as HTMLButtonElement;
  const $content = $wrapper.querySelector('.cya11y-statement-content') as HTMLElement;

  // Inject the generated HTML
  $content.innerHTML = renderStatement();

  $backBtn.addEventListener('click', () => {
    onBack();
  });

  return $wrapper;
}
